import { Component } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../interfaces/plugin-preview-component.interface';
import { TemplateDetailsData } from '../../../../../models/wizard-plugin-models/template-details-data';

@Component({
  selector: 'app-template-details-preview',
  templateUrl: './template-details-preview.component.html',
  styleUrl: './template-details-preview.component.css'
})
export class TemplateDetailsPreviewComponent implements IPluginPreviewComponent {
  previewData: TemplateDetailsData | undefined;
  setData(data: any): void {
    if (data instanceof TemplateDetailsData) {
      this.previewData = data;
    }
  }
}
